(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Invalid",
            {
                url: "/Invalid?param={parameter}",
                component: "invalid",
                resolve: {
                    param: ["$stateParams", function ($stateParams) {
                        return $stateParams.param;
                    }]
                }
            });
    }]);

    app.component("invalid",
    {
        templateUrl: "/App/Register/Invalid/invalid-template.html",
        bindings: {
            param: "<"
        }
    });

})(window.app, window.angular);